import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import LoadingScreen from './components/LoadingScreen';
import Navigation from './components/Navigation';
import Hero from './sections/Hero';
import Cursos from './sections/Cursos';
import Tienda from './sections/Tienda';
import Blog from './sections/Blog';
import Donaciones from './sections/Donaciones';
import Contacto from './sections/Contacto';
import LoginModal from './components/LoginModal';
import Footer from './components/Footer';
import PWAInstallPrompt from './components/PWAInstallPrompt';
import './App.css';

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [showLogin, setShowLogin] = useState(false);
  const [activeSection, setActiveSection] = useState('inicio');

  useEffect(() => {
    // Simular carga inicial
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 3500);

    return () => clearTimeout(timer);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setActiveSection(sectionId);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-mystic">
      <AnimatePresence mode="wait">
        {isLoading ? (
          <LoadingScreen key="loading" />
        ) : (
          <motion.div
            key="content"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8 }}
          >
            <Navigation 
              onNavigate={scrollToSection} 
              onLoginClick={() => setShowLogin(true)}
              activeSection={activeSection}
            />
            
            <main>
              <section id="inicio">
                <Hero onExplore={() => scrollToSection('cursos')} />
              </section>
              
              <section id="cursos">
                <Cursos />
              </section>
              
              <section id="tienda">
                <Tienda />
              </section>
              
              <section id="blog">
                <Blog />
              </section>
              
              <section id="donaciones">
                <Donaciones />
              </section>
              
              <section id="contacto">
                <Contacto />
              </section>
            </main>
            
            <Footer onNavigate={scrollToSection} />
            
            <LoginModal isOpen={showLogin} onClose={() => setShowLogin(false)} />
            
            {/* PWA Install Prompt */}
            {!isLoading && <PWAInstallPrompt />}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default App;
